import {Action} from '@ngrx/store';
import {BijbEvent} from '../../../models/bijb-event';

export class GetCurrentUserAction implements Action {
  public static readonly type = 'GetCurrentUserAction';

  constructor(public bijbEvent: BijbEvent) {
  }

  public type = GetCurrentUserAction.type;
}
